import {toObservable} from '@angular/core/rxjs-interop';
import {Clinician} from '@domain/clinician/clinician';
import {User} from '@domain/user';
import {ClinicService} from '@infrastructure/admin/clinics/clinic.service';
import {AgendaService} from '@infrastructure/clinician/agenda/agenda.service';
import {ClinicianService} from '@infrastructure/clinician/clinician.service';
import {UserType} from '@infrastructure/generic-auth/user-type.enum';
import {LocalStorageKeys} from '@shared/utils/local-storage-keys.enum';
import {combineLatest, EMPTY, map, Observable, skip, take} from 'rxjs';
import {AdminService} from 'src/infrastructure/admin/admin.service';
import {GenericAuthService} from 'src/infrastructure/generic-auth/generic-auth.service';
import {OwnerService} from 'src/infrastructure/owner/owner.service';

export const appInitializerFactory = (
    genericAuthService: GenericAuthService,
    ownerService: OwnerService,
    adminService: AdminService,
    clinicianService: ClinicianService,
    adminClinicsService: ClinicService,
    clinicianAgendaService: AgendaService
) =>
{
    const user$ = combineLatest([
        toObservable(ownerService.owner), toObservable(ownerService.loading),
        toObservable(adminService.admin), toObservable(adminService.loading),
        toObservable(clinicianService.clinician), toObservable(clinicianService.loading)
    ]).pipe(skip(1), take(1), map(([user]) => user));
    
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    return (): Observable<void | User | Clinician> =>
    {
        if (!genericAuthService.hasAnyTokenStoredForUser(window.location.href))
        {
            return EMPTY;
        }

        const userType = genericAuthService.getUserTypeFromApiRequest(window.location.href, '');
        
        if (userType === UserType.OWNER && !!localStorage.getItem(LocalStorageKeys.OWNER_ACCESS_TOKEN))
        {
            ownerService.getOwnerDetails();
        }
        
        if (userType === UserType.ADMIN && !!localStorage.getItem(LocalStorageKeys.ADMIN_ACCESS_TOKEN))
        {
            adminService.getAdminDetails();
            adminClinicsService.getClinics();
        }
        
        if (userType === UserType.CLINICIAN && !!localStorage.getItem(LocalStorageKeys.CLINICIAN_ACCESS_TOKEN))
        {
            clinicianService.getClinicianDetails();
            clinicianService.checkForPendingInvitations();
            clinicianAgendaService.getSuspendedStatus();
        }

        return user$;
    };
};
